// paginator.store.js
import { defineStore } from 'pinia';

export const usePaginationStore = defineStore('pagination', {
  state: () => ({
    current_page: 1,
    last_page: 1,
    per_page: 20,
    from: 0,
    to: 0,
    total: 0,
  }),
  getters: {
    paginationDataForRequest: (state) => ({
      page: state.current_page,
      per_page: state.per_page,
    }),
    paginationData: (state) => ({
      current_page: state.current_page,
      last_page: state.last_page,
      from: state.from,
      to: state.to,
      per_page: state.per_page,
      total: state.total,
    }),
  },
  actions: {
    setPaginationData(data = {}) {
      if (typeof data !== 'object') return;

      this.total = Number(data['x-wp-total']) || 0;
      this.last_page = Number(data['x-wp-totalpages']) || 1;

      // Don't touch current_page unless you want to reset it
      this.updateFromTo();
    },
    setCurrentPage(page) {
      this.current_page = page || 1;
      this.updateFromTo();
    },
    setPerPage(perPage = 8) {
      this.per_page = perPage;
      this.updateFromTo();
    },
    incrementCurrentPage() {
      if (this.current_page < this.last_page) {
        this.current_page++;
        this.updateFromTo();
      }
    },
    decrementCurrentPage() {
      if (this.current_page > 1) {
        this.current_page--;
        this.updateFromTo();
      }
    },
    updateFromTo() {
      if (this.total === 0) {
        this.from = 0;
        this.to = 0;
      } else {
        this.from = (this.current_page - 1) * this.per_page + 1;
        this.to = Math.min(this.from + this.per_page - 1, this.total);
      }
    },
  },
});
